'use client';

import { c } from '../../../utils/tailwind-merge';
import { Popover } from '../Popover/Popover';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../Tooltip/TooltipRadix';
import type { BadgeProps, BadgePropsContent } from './Badge.types';

const BadgeContent = ({ text }: BadgePropsContent) => (
  <div className="flex" aria-label={text}>
    {text}
  </div>
);

const InteractivePopover = ({
  text,
  content,
}: {
  text: string;
  content: React.ReactNode;
}) => {
  return (
    <Popover>
      <Popover.Trigger
        aria-label={text}
        className="cursor-pointer border-none bg-transparent p-0"
      >
        <BadgeContent text={text} />
      </Popover.Trigger>
      <Popover.Content className={c('z-50')}>{content}</Popover.Content>
    </Popover>
  );
};

export const Badge = ({
  text,
  tooltip,
  popover,
  interactive = false,
  className = '',
}: BadgeProps) => {
  return (
    <div
      className={c(
        'rounded-sm bg-grey-100 px-1.5 py-0.5 text-xs font-normal tracking-tighter text-grey-700',
        className
      )}
    >
      {!tooltip && !popover ? (
        <BadgeContent text={text} />
      ) : interactive || popover ? (
        <InteractivePopover text={text} content={popover || tooltip} />
      ) : (
        <Tooltip>
          <TooltipProvider>
            <TooltipTrigger aria-label={text}>
              <BadgeContent text={text} />
            </TooltipTrigger>
            <TooltipContent>{tooltip}</TooltipContent>
          </TooltipProvider>
        </Tooltip>
      )}
    </div>
  );
};
